import React from 'react';
import { Header } from 'src/design/organisms/Header';
import { useWbs } from 'src/routes/Jobs/WBS/contexts/WbsContext';
import { useJobs } from 'src/hooks/useJobs';
import { SimpleTracker } from './components/SimpleTracker';
export const TrackerPage: React.FC = () => {
  const { selectedJob } = useJobs();
  const { wbsDirty, refreshWbs } = useWbs();

  // WbsContext is an app-level singleton; pick up Progress Viewer edits that
  // pre-warmed too late (or were skipped) when entering this page.
  React.useEffect(() => {
    if (wbsDirty) refreshWbs();
  }, []);

  return (
    <>
      <Header
        title="Tracker"
        helpText="View job performance and progress based on the job's work breakdown structure."
        breadcrumbProps={{
          items: [
            { text: 'Jobs', href: '/jobs' },
            {
              text: `${selectedJob?.name} - ${selectedJob?.jobNumber}`,
              href: `/jobs/${selectedJob?.id}/summary`,
            },
            { text: 'Tracker', href: '' },
          ],
        }}
      />
      {selectedJob && (
        <SimpleTracker
          jobNumber={selectedJob.jobNumber}
          jobId={selectedJob.id}
        />
      )}
    </>
  );
};
